import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import "./ConfirmationMsgModal.scss";
import CloseIcon from "@mui/icons-material/Close";
import CustomModalActionButton from "../../MUIBaseComponents/Modal/CustomModalActionButton";
import { IConfirmationMsgModal } from "./IConfirmationMsgModal";

const ConfirmationMsgModal = ({
  open,
  handleClose,
  onConfirm,
  name,
  title,
  msg,
  isLoading = false,
  isCancel = false,
  confirmButtonText,
  loadingText,
}: IConfirmationMsgModal) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: "20px",
          backgroundColor: "var(--background-color)",
          //  boxShadow: "0px 10px 40px var(--box-shadow-heatmap-table)",
          width: window.innerWidth > 768 ? "30%" : "100%",
          minWidth: { sm: "380px" },
          maxWidth: "480px",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle className="confirm-modal-title">
        <div className="confirm-title-header">
          <Typography variant="h6" className="heading">
            {title ?? "Ok"}
          </Typography>
          <IconButton onClick={handleClose} className="close-btn">
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent className="confirm-modal-container">
        <Typography className="confirm-details">
          {/* Are you sure you want to {msg ?? 'confirm'} this {name ?? 'business'}? */}
          {msg}
        </Typography>
      </DialogContent>

      <CustomModalActionButton
        className="confirm-modal-buttons"
        handleClose={handleClose}
        onConfirm={onConfirm}
        cancelText={isCancel ? "" : "Cancel"}
        // saveText={isCancel ? "Cancel" : "Ok"}
        saveText={isCancel ? "Cancel" : confirmButtonText || "Ok"}
        isLoading={isLoading}
        isCancel={isCancel}
        loadingText={loadingText}
      />
    </Dialog>
  );
};

export default ConfirmationMsgModal;
